import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_CUSTOM_RANGE, UPDATE_DATA_BY_STAFF, UPDATE_DATES } from "../common/saga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import PropTypes from "prop-types";

const Filters = ({ filtersDirtySt, moduleName }) => {
  const dispatch = useDispatch();
  const {
    filters,
    staffFiltersLoading,
    selectedRequestDates,
    selectedRangeOption,
    selectedStaffFilters,
    rangeOptions,
    currentUser
  } = useSelector((state) => state[moduleName]);

  return (
    <>
      <div className="select-box" style={{ width: "190px" }}>
        <p className="offers-title">Staff</p>
        {!staffFiltersLoading ? (
          <MultiSelectDropdown
            options={filters.staff_values}
            selectedFilters={selectedStaffFilters}
            placeholder="Select Staff"
            initFiltersLoaded
            enableOnly
            numberDisplayed={0}
            includeSelectAll
            haveOnSelectChange
            onSelectChange={(data) =>
              dispatch({
                type: UPDATE_DATA_BY_STAFF + moduleName,
                payload: { data, chartType: moduleName }
              })
            }
          />
        ) : (
          <button className="picky__input">
            <LoadingAnimation uiLoader />{" "}
          </button>
        )}
      </div>
      <div className="select-box" style={{ width: "360px" }}>
        <p className="offers-title">Date Range</p>
        {!filtersDirtySt && (
          <MultiSelectDropdown
            options={rangeOptions}
            selectedFilters={selectedRangeOption}
            includeFilter={false}
            placeholder="Select Range"
            onSelectChange={(data) =>
              dispatch({
                type: UPDATE_CUSTOM_RANGE + moduleName,
                payload: { data, chartType: moduleName }
              })
            }
          />
        )}
      </div>
      <div className="date-select-box select-box multi">
        <p className="offers-title">Date</p>
        {!filtersDirtySt && (
          <ReactDatePicker
            startDate={selectedRequestDates.startDate}
            endDate={selectedRequestDates.endDate}
            minDate={currentUser.calendarStartDate}
            calendarEndDate={currentUser.calendarEndDate}
            isRangePicker
            updateDates={(startDate, endDate) =>
              dispatch({
                type: UPDATE_DATES + moduleName,
                payload: { startDate, endDate, chartType: moduleName }
              })
            }
          />
        )}
      </div>
    </>
  );
};

export default Filters;

Filters.propTypes = {
  filtersDirtySt: PropTypes.bool,
  chartType: PropTypes.string,
  moduleName: PropTypes.string
};
